import {ChangeDetectionStrategy, Component, Inject, Output} from '@angular/core';
import {WINDOW} from '../../../shared/services/window.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {

    @Output() currentYear = new Date().getFullYear().toString();

    constructor(@Inject(WINDOW) private window: Window) {
    }

    scrollToTop(): void {
        this.window.scrollTo({
            behavior: 'smooth',
            top: 0
        });
    }
}
